export default __webpack_public_path__ + "static/media/end_of_call.c9892fa6.ogg";